// ═══════════════════════════════════════════════════════════════════════════════
// Pairing code copy icons (clipboard / check)
// ═══════════════════════════════════════════════════════════════════════════════

type PairingCopyIconProps = {
  className?: string;
};

export const PairingCopyClipboardIcon = ({ className = 'h-5 w-5' }: PairingCopyIconProps) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
    />
  </svg>
);

export const PairingCopyCheckIcon = ({ className = 'h-5 w-5' }: PairingCopyIconProps) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
  </svg>
);
